var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ESortOrder } from "@domains/utils/sort";
import { HoldingReportData, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { Filters, SortData, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { BaseUseCase } from "@domains/useCases/UseCaseBase";
import { reportsTabAndDropDownData, } from "@frameworks/web/components/Reports/CommonComponent/constant";
var HoldingReportUseCase = /** @class */ (function (_super) {
    __extends(HoldingReportUseCase, _super);
    function HoldingReportUseCase(holdingReportRepo) {
        var _this = _super.call(this) || this;
        _this.holdingReportRepo = holdingReportRepo;
        return _this;
    }
    HoldingReportUseCase.prototype.fetchResult = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var homeDTOList, ArrayOfSortData, simpleFilter, assetFilter, prodfilterSet, prodfilters, productAssetFilter, finalData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.holdingReportRepo.getHoldingReportData(req)];
                    case 1:
                        homeDTOList = _a.sent();
                        ArrayOfSortData = new Array(new SortData("Alphabetical", "displayName", ESortOrder.DESC), new SortData("P&L %", "pnlChangePercentage", ESortOrder.UNCHANGED), new SortData("P&L absolute", "pnl", ESortOrder.UNCHANGED), new SortData("LTP Change %", "changePercentage", ESortOrder.UNCHANGED), new SortData("Day Change", "dayChange", ESortOrder.UNCHANGED), new SortData("Investment Value", "investmentValue", ESortOrder.UNCHANGED), new SortData("Current Value", "currentValue", ESortOrder.UNCHANGED));
                        simpleFilter = new Filters("Scrip Filter", [
                            { title: "Tradeable holdings", key: "tradable", selected: false },
                            { title: "Pledged Scrips", key: "pledge", selected: false },
                            { title: "CUSA Scrips", key: "Cusa", selected: false },
                            { title: "MTF Scrips", key: "mtf", selected: false },
                        ]);
                        assetFilter = new Filters("Asset filter", [
                            { title: "Equity", key: "EQ", selected: false },
                            { title: "Fixed Income", key: "FI", selected: false },
                            { title: "Managed Portfolio", key: "MAP", selected: false },
                            //{ title: "Derivatives", key: "FnO", selected: false },
                            { title: "Commodity", key: "CO", selected: false },
                            { title: "Other", key: "RE", selected: false },
                        ]);
                        prodfilterSet = new Set();
                        Object.values(reportsTabAndDropDownData).forEach(function (x) {
                            x.dropDownList.forEach(function (y) {
                                prodfilterSet.add({
                                    title: y.display,
                                    key: y.value,
                                    selected: false,
                                });
                            });
                        });
                        prodfilters = Array.from(prodfilterSet);
                        productAssetFilter = new Filters("Product Asset filter", __spreadArray([], __read(prodfilters), false));
                        if (homeDTOList) {
                            finalData = new HoldingReportData(homeDTOList.HoldingSummary, homeDTOList.HoldingDetails, "", { simpleFilter: simpleFilter, assetFilter: assetFilter, productAssetFilter: productAssetFilter }, ArrayOfSortData, false, homeDTOList.isOmneOnly);
                            return [2 /*return*/, finalData];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    return HoldingReportUseCase;
}(BaseUseCase));
export default HoldingReportUseCase;
